import React from 'react';
import TableRow from "@mui/material/TableRow";
import Skeleton from '@mui/material/Skeleton';
import TableCell from "@mui/material/TableCell";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import {useTranslation} from "react-i18next";
import SearchIcon from "@mui/icons-material/Search";
import Button from "../../../inputs/Button";

// Using inline styles for better compatibility with MUI v5
const useStyles = () => ({
    selected: {
        backgroundColor: '#00000052',
    },
    selectable: {
        '&:hover': {
            cursor: 'pointer',
            backgroundColor: '#00000052',
        }
    },
});

const Row = ({template, value, setValue, mode}) => {
    const {t} = useTranslation();
    const display = template !== null;
    const classes = useStyles();
    const isSelected = template ? (value ? value.Content_Cms_Template__ === template.Content_Cms_Template__ : false) : false;


    return (
        <TableRow style={{
            ...(isSelected ? classes.selected || {} : {}),
            ...(classes.selectable || {})
        }}>
            <TableCell>
                {!display && <Skeleton/>}
                {display && <span>{template.Name}</span>}
            </TableCell>
            <TableCell align='right'>
                {!display && <Skeleton/>}
                {display && <Button
                    variant={mode === 'manage' ? 'contained' : 'text'}
                    color="primary"
                    endIcon={mode === 'manage' ? <SearchIcon/> : <ArrowForwardIcon/>}
                    onClick={() => setValue(template)}
                >
                    {mode === 'manage' ? t('view_btn') : t('select_btn')}
                </Button>}
            </TableCell>
        </TableRow>
    );
};


export default Row;